/**
 * Remove empty keys from object
 * @param { Object } [obj={}] value to format
 * @returns { Object } Data procesed with the value in it
 */
export const removeEmptyAttribute = obj => {
  Object.keys(obj).forEach((key) => (!obj[key] && (obj[key] !== undefined || obj[key] !== '' || obj[key] !== null)) && delete obj[key])
  return obj
}
